export default __webpack_public_path__ + "mfa-mobile-logo.cae85e0bae9041bbd2352238476ba008.svg";